const LOAD_ALERTS_HISTORY = 'ALERTS_HISTORY/LOAD';
const LOAD_ALERTS_HISTORY_WITH_FILTER = 'ALERTS_HISTORY/LOAD_ALL_FILTERED';
const CHANGE_ALERTS_HISTORY_ORDER = 'ALERTS_HISTORY/CHANGE_ORDER';

export { LOAD_ALERTS_HISTORY, LOAD_ALERTS_HISTORY_WITH_FILTER, CHANGE_ALERTS_HISTORY_ORDER };
